export default {
    methods: {
    toggle_active: function(x) {
      console.log('toggle', '#tag_' + x);


      $('#tag_' + x).removeClass('btn-info');
      $('#tag_' + x).toggleClass('btn-success');
		// for (var i = 0; i < keywords_chosen.length; i++) {	
		//   if ((x.substring(x.length-2, x.length) != keywords_chosen[i].substring(
		//   		  	keywords_chosen[i].length-2, keywords_chosen[i].length))
		//   	&& (x.substring(0, keywords_chosen[i].length-2) == keywords_chosen[i].substring(0, keywords_chosen[i].length-2))) {
  //         	$('[id^="tag_' + keywords_chosen[i].substring(0, keywords_chosen[i].length-2) + '"]').addClass('btn-info');
  //    	 }
		// }

		// for (var i = 0; i < keywords_chosen.length; i++) {	
		//   for (var j = i + 1; j < keywords_chosen.length;j++) {	
		//   	console.log(keywords_chosen[i], keywords_chosen[j], i, j);
		//   	if (((keywords_chosen[i].substring(0,keywords_chosen[i].length-2) == 
		//   			  		keywords_chosen[i].substring(0,keywords_chosen[j].length-2))))// &&
		//   		// ((keywords_chosen[i].substring(keywords_chosen[i].length-2, keywords_chosen[i].length) != 
		//   		// 	  		x.substring(x.length-2, x.length)))) 
		//   	{
		//   		$('#tag_' + keywords_chosen[i].substring(0, keywords_chosen[i].length-2) + x.substring(
  //         		x.length-2, x.length)).addClass('btn-other');
		//   	}
		//   }
		// }
    },
}
}


// WEBPACK FOOTER //
// ./src/mixins/toggle_active_multilang.js